/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APISupplierAutocompleteSuggestion } from './APISupplierAutocompleteSuggestion';
import {
    APISupplierAutocompleteSuggestionFromJSON,
    APISupplierAutocompleteSuggestionFromJSONTyped,
    APISupplierAutocompleteSuggestionToJSON,
} from './APISupplierAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APISupplierAutocompleteResponse
 */
export interface APISupplierAutocompleteResponse {
    /**
     * 
     * @type {Array<APISupplierAutocompleteSuggestion>}
     * @memberof APISupplierAutocompleteResponse
     */
    suggestions: Array<APISupplierAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APISupplierAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APISupplierAutocompleteResponse interface.
 */
export function instanceOfAPISupplierAutocompleteResponse(value: object): value is APISupplierAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APISupplierAutocompleteResponseFromJSON(json: any): APISupplierAutocompleteResponse {
    return APISupplierAutocompleteResponseFromJSONTyped(json, false);
}

export function APISupplierAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplierAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APISupplierAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APISupplierAutocompleteResponseToJSON(value?: APISupplierAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APISupplierAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

